"use client";

import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
	"672182c47c27b3aee8c4eef74b5e49e0Tz0xMjc0MTgsRT0xODA3NDAxNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y"
);

export default function MuiXLicense() {
	return null;
}
